/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import * as ScreenPermissions from 'core/EventActions'
import { hasAccesPermits } from 'core/utils'

import HistoricalNetCapVerificationHistory from './HistoricalNetVerification'
import NetCapVerification from './NetVerification'
import MisoNetVerificationDataExport from './MisoNetCapVerifiactionExport'
import MisoNetVerImportData from './MisoNetCapVerificationImport'
import NetVerificationSummary from './NetVerificationSummary'
import MisoHistVerificationSummary from './MisoHistVerificationSummary'

export const MisoNetCapVerificationContainer = ({
  actionPermits,
  envConfig,
}) => {
  const MisoVerificationTestData = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          ScreenPermissions.MISO_NET_CAP_VERIFICATION,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_WRITE,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT,
          ScreenPermissions.MISO_NET_CAP_VERIFICATION_EXPORT,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // const MisoNetCapacityVerificationWrite = useMemo(
  //   _ =>
  //     hasAccesPermits({
  //       authGodMode: envConfig.authGodMode,
  //       actionPermits,
  //       eventActions: [
  //         ScreenPermissions.MISO_NET_CAP_VERIFICATION_WRITE,
  //         ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT,
  //       ],
  //       matchAny: true,
  //     }),
  //   [actionPermits, envConfig.authGodMode]
  // )

  const MisoNetCapacityVerificationImport = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_NET_CAP_VERIFICATION_IMPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const misoNetCapacityVerificationExportPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MISO_NET_CAP_VERIFICATION_EXPORT],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  return (
    <React.Fragment>
      {MisoNetCapacityVerificationImport && (
        <Route
          exact
          path="/miso/net-cap-verification-data-import"
          component={MisoNetVerImportData}
        />
      )}
      {misoNetCapacityVerificationExportPermission && (
        <Route
          exact
          path="/miso/net-cap-verification-data-export"
          component={MisoNetVerificationDataExport}
        />
      )}
      {MisoVerificationTestData && (
        <Route
          exact
          path="/miso/net-cap-verification"
          component={NetCapVerification}
        />
      )}
      {MisoVerificationTestData && (
        <Route
          exact
          path="/miso/net-cap-verification-summary"
          component={NetVerificationSummary}
        />
      )}
      {MisoVerificationTestData && (
        <Route
          exact
          path="/miso/net-cap-verification-hist"
          component={HistoricalNetCapVerificationHistory}
        />
      )}
      {MisoVerificationTestData && (
        <Route
          exact
          path="/miso/net-cap-verification-hist-summ"
          component={MisoHistVerificationSummary}
        />
      )}
    </React.Fragment>
  )
}
